import './AccountStyles.css'

export function SectionHeader({ children }: { children: React.ReactNode }) {
  return <div className="about__section-header">{children}</div>
}

export function Group({ children }: { children: React.ReactNode }) {
  return <div className="about__group">{children}</div>
}

export function Row({
  label,
  children,
}: {
  label: string
  children?: React.ReactNode
}) {
  return (
    <div className="about__row">
      <span className="about__row-label">{label}</span>
      {children}
    </div>
  )
}

export function TappableRow({
  label,
  onClick,
  onInfo,
  children,
}: {
  label: string
  onClick: () => void
  onInfo?: () => void
  children?: React.ReactNode
}) {
  if (onInfo) {
    // Can't nest <button> inside <button>, so the row becomes a div.
    // Label + ⓘ are grouped together (flex:1) so the ⓘ sits right
    // after the text rather than aligned in a column on the far right.
    return (
      <div
        className="about__row about__row--tappable about__row--with-info"
        onClick={onClick}
      >
        <span className="about__row-label-group">
          <span>{label}</span>
          <button
            className="about__row-info-btn"
            onClick={(e) => { e.stopPropagation(); onInfo() }}
            aria-label={`About ${label}`}
          >
            ⓘ
          </button>
        </span>
        <span className="about__row-right">{children}</span>
      </div>
    )
  }

  return (
    <button className="about__row about__row--tappable" onClick={onClick}>
      <span className="about__row-label">{label}</span>
      <span className="about__row-right">{children}</span>
    </button>
  )
}

export function InfoPopover({
  title,
  body,
  onDismiss,
}: {
  title: string
  body: string
  onDismiss: () => void
}) {
  return (
    <>
      <div className="info-popover-backdrop" onClick={onDismiss} />
      <div className="info-popover">
        <p className="info-popover__title">{title}</p>
        <p className="info-popover__body">{body}</p>
        <button className="info-popover__dismiss" onClick={onDismiss}>
          Got it
        </button>
      </div>
    </>
  )
}
